<template>
  <Stack class="questions-view">
    <Stack gap="2">
      <Title>Dossier</Title>
      <p>Choose which fields of the Dossier you want to ask your Client to fill out.</p>
      <div>
        <Toggle v-model="clientPortalStore.portalRequest.ask_for_dossier">
          Ask the client to fill Dossier fields
        </Toggle>
        <YesNoBadge
          :bool="clientPortalStore.portalRequest.ask_for_dossier"
          yes-label="Enabled"
          no-label="Disabled"
        />
      </div>
    </Stack>

    <LoaderWithText v-if="!clientPortalStore.hasFetched || clientPortalStore.isLoading" />

    <div
      v-else
      class="questions-main"
    >
      <div class="questions-side">
        <Menu>
          <MenuItem
            v-for="section in allDossierSections"
            :key="section.value"
            :active="section.value === selectedSection"
            @click="selectedSection = section.value"
          >
            {{ section.label }}
          </MenuItem>
        </Menu>
      </div>

      <div class="questions-body">
        <Stack
          gap="0"
          class="list"
        >
          <Field
            v-for="field in displayedFields"
            :key="field.pathString"
            :field="field"
            @update:show="setItem(field.pathString, 'show', $event)"
            @update:required="setItem(field.pathString, 'required', $event)"
          />
        </Stack>
      </div>
    </div>
  </Stack>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { prettifyMixedCase } from '@frontend/shared/Util.js';
import { LoaderWithText, Menu, MenuItem, Stack, Title, Toggle, YesNoBadge } from '@stakeui';
import Field from '../components/Field.vue';
import { useClientPortalStore } from '@frontend/ui/stores/clientPortalStore';

const clientPortalStore = useClientPortalStore();

defineProps({
  entityExternalId: {
    type: String,
    default: '',
  },
});

const selectedSection = ref('');

// Methods
const setItem = (pathString, key, value) => {
  const matches = clientPortalStore.allFields
      .filter(i => i.pathString === pathString || i.pathString.startsWith(pathString));

  if (matches.length === 0) {
    return;
  }

  matches.forEach(match => {
    if (key === 'required' && value === true && match.show === false) {
      match.show = true;
    }

    match[key] = value;
  });
};

// Computed
const allDossierSections = computed(() => {
  const props = clientPortalStore.dossierTemplate?.properties || {};

  return Object.keys(props).map(key => ({
    label: prettifyMixedCase(key),
    value: key,
  }));
});

const displayedFields = computed(() => {
  return clientPortalStore.allFields.filter(item => item.section === selectedSection.value);
});

onMounted(() => {
  if (
    selectedSection.value === '' &&
      Object.keys(clientPortalStore.dossierTemplate?.properties).length > 0
  ) {
    selectedSection.value = Object.keys(clientPortalStore.dossierTemplate?.properties)[0];
  }
});
</script>

<style scoped>
.questions-view {
  overflow: hidden;
}

.questions-main {
  display: flex;
  gap: 2em;
  overflow: hidden;
}

.questions-side {
  width: 12em;
  flex-shrink: 0;
}

.questions-main {
  flex-grow: 1;
  overflow: hidden;
}

.questions-body {
  background-color: #fff;
  box-shadow: var(--box-inner-shadow);
  border-radius: 0.75em;
  padding: 1.5em;
  width: 100%;
}

.list {
  gap: 1px;
}
</style>
